module.exports = __webpack_public_path__ + "static/media/publishIcon.796809cf.svg";